import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/Index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
